import { render, staticRenderFns } from "./FeeStandard.vue?vue&type=template&id=2765e99e&scoped=true"
import script from "./FeeStandard.vue?vue&type=script&lang=ts"
export * from "./FeeStandard.vue?vue&type=script&lang=ts"
import style0 from "./FeeStandard.vue?vue&type=style&index=0&id=2765e99e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2765e99e",
  null
  
)

export default component.exports